import { HttpResponse } from 'msw';

import { DEVICE_TYPE } from '../constants';
import { getInterfaceCounters } from '../helper';

type LegacyBody = { command?: string };

export function handleInterfaceLegacy(
  body: LegacyBody,
): ReturnType<typeof HttpResponse.json> {
  const command = body.command ?? '';
  switch (command) {
    case 'get interfaces state':
      return HttpResponse.json(
        Array.from({ length: 24 }, (_, idx) => ({
          interface: idx + 1,
          state: Math.random() > 0.35,
          speed: idx < 4 ? '1G' : '100M',
          duplex: true,
          mac: `02:00:00:00:${String(Math.floor(idx / 16)).padStart(2, '0')}:${String(idx % 16).padStart(2, '0')}`,
        })),
        { status: 200 },
      );
    case 'get counters':
      return HttpResponse.json(getInterfaceCounters(DEVICE_TYPE), {
        status: 200,
      });
    case 'get bsp state':
      return HttpResponse.json({ bsp: true }, { status: 200 });
    case 'set bsp state':
      return HttpResponse.json({ ok: true }, { status: 200 });
    case 'get interfaces':
      return HttpResponse.json(
        Array.from({ length: 24 }, (_, idx) => ({
          interface: idx + 1,
          name: `Port ${idx + 1}`,
          up: true,
          autoneg: true,
          speed: idx < 4 ? 1000 : 100,
          duplex: true,
          mdi: 'auto',
          diagnostics: false,
        })),
        { status: 200 },
      );
    case 'set interfaces':
      return HttpResponse.json({ ok: true }, { status: 200 });

    default:
      return HttpResponse.json(
        {
          error: 'not implemented',
          msg: `Mock missing for interface:${command}`,
        },
        { status: 400 },
      );
  }
}

export function handleWebserverLegacy(
  body: LegacyBody,
): ReturnType<typeof HttpResponse.json> {
  const command = body.command ?? '';
  switch (command) {
    case 'get config':
      return HttpResponse.json({ http: true }, { status: 200 });
    case 'set config':
    case 'upload':
    case 'reset':
      return HttpResponse.json({ ok: true }, { status: 200 });
    case 'is default':
      return HttpResponse.json({ isDefault: true }, { status: 200 });
    case 'public certificate': {
      const pem =
        '-----BEGIN CERTIFICATE-----\nMOCK\n-----END CERTIFICATE-----\n';
      return HttpResponse.json(
        { pubKey: Array.from(new TextEncoder().encode(pem)) },
        { status: 200 },
      );
    }
    default:
      return HttpResponse.json(
        {
          error: 'not implemented',
          msg: `Mock missing for webserver:${command}`,
        },
        { status: 400 },
      );
  }
}

export function handlePoeLegacy(
  body: LegacyBody,
): ReturnType<typeof HttpResponse.json> {
  const command = body.command ?? '';
  switch (command) {
    case 'get limit':
      return HttpResponse.json([{ limit: 120 }, { limit: 120 }], {
        status: 200,
      });
    case 'get port cfg state':
      return HttpResponse.json(
        Array.from({ length: 16 }, (_, i) => ({
          name: `PD${i + 1}`,
          enable: i % 2 === 0,
          limit: 0,
          limit_pwr: 0,
          prio: 3,
          fault: false,
        })),
        { status: 200 },
      );
    case 'set port cfg state':
      return HttpResponse.json({ ok: true }, { status: 200 });
    case 'get poe state':
      return HttpResponse.json(
        Array.from({ length: 16 }, () => ({
          poeclass: Math.random() > 0.3 ? 3 : -1,
          status: Math.floor(Math.random() * 6),
        })),
        { status: 200 },
      );
    case 'get global state':
      return HttpResponse.json({ usedBudget: 187 }, { status: 200 });
    default:
      return HttpResponse.json(
        { error: 'not implemented', msg: `Mock missing for poe:${command}` },
        { status: 400 },
      );
  }
}
